import Vue from 'vue'
import VueRouter from 'vue-router'

import Actions from '@/views/Actions.vue'
import ActionsPending from '@/views/ActionsPending.vue'
import Home from '@/views/Home.vue'
import Index from '../views/Index.vue'
import Login from '@/views/Login.vue'
import InterestEdit from '@/views/InterestEdit.vue'
import Interests from '@/views/Interests.vue'
import InterestDefaultEdit from '@/views/InterestDefaultEdit.vue'
import InterestDefaults from '@/views/InterestDefaults.vue'
import Logs from '@/views/Logs.vue'
import LogView from '@/views/LogView.vue'
import OrganizationEdit from '@/views/OrganizationEdit.vue'
import Organizations from '@/views/Organizations.vue'
import PasswordResetConfirm from '@/views/PasswordResetConfirm'
import PasswordResetForm from '@/views/PasswordResetForm'
import PasswordResetRequest from '@/views/PasswordResetRequest'
import Reports from '@/views/Reports.vue'
import SiteEdit from '@/views/SiteEdit.vue'
import Sites from '@/views/Sites.vue'
import UserEdit from '@/views/UserEdit.vue'
import Users from '@/views/Users.vue'
import UserImport from '@/views/UserImport.vue'
import UserInvite from '@/views/UserInvite.vue'
import VerifyEmail from '@/views/VerifyEmail.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Index,
    children: [
      {
        path: '',
        component: Home,
        name: 'home'
      },
      {
        path: '/login',
        component: Login,
        name: 'login'
      },
      {
        path: '/actions',
        component: Actions,
        name: 'actions'
      },
      {
        path: '/actions/pending',
        component: ActionsPending,
        name: 'actionsPending'
      },
      {
        path: '/interests',
        component: Interests,
        name: 'interests'
      },
      {
        path: '/interest/:id',
        component: InterestEdit,
        name: 'interestEdit'
      },
      {
        path: '/interestdefaults',
        component: InterestDefaults,
        name: 'interestdefaults'
      },
      {
        path: '/interestdefaults/:id',
        component: InterestDefaultEdit,
        name: 'interestdefaultEdit'
      },
      {
        path: '/logs',
        component: Logs,
        name: 'logs'
      },
      {
        path: '/logs/:id',
        component: LogView,
        name: 'logView'
      },
      {
        path: '/organizations',
        component: Organizations,
        name: 'organizations'
      },
      {
        path: '/organizations/:id',
        component: OrganizationEdit,
        name: 'organizationEdit'
      },
      {
        path: '/reports',
        component: Reports,
        name: 'reports'
      },
      {
        path: '/sites',
        component: Sites,
        name: 'sites'
      },
      {
        path: '/sites/:id',
        component: SiteEdit,
        name: 'siteEdit'
      },
      {
        path: '/users',
        component: Users,
        name: 'users'
      },
      {
        path: '/users/:id',
        component: UserEdit,
        name: 'userEdit'
      },
      {
        path: '/users/import',
        component: UserImport,
        name: 'userImport'
      },
      {
        path: '/users/invite',
        component: UserInvite,
        name: 'userInvite'
      }
    ]
  },
  {
    path: '/passwordreset/form',
    component: PasswordResetForm,
    name: 'passwordResetForm'
  },
  {
    path: '/passwordreset/request',
    component: PasswordResetRequest,
    name: 'passwordResetRequest'
  },
  {
    path: '/passwordreset/confirm',
    component: PasswordResetConfirm,
    name: 'passwordResetConfirm'
  },
  {
    path: '/verifyemail',
    component: VerifyEmail,
    name: 'verifyEmail'
  },
  {
    path: '*',
    redirect: ''
  }
]

const router = new VueRouter({
  routes
})

export default router
